/**
 * Chrome and Brave open a year list from the calendar header.
 * Safari (and every iOS browser, which uses WebKit) only offers month arrows.
 */
export function nativeDatePickerSupportsYearJump() {
  if (typeof navigator === "undefined") return true;

  const ua = navigator.userAgent || "";
  const isIos =
    /iP(ad|hone|od)/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  if (isIos) return false;

  const isSafari =
    /Safari/i.test(ua) &&
    !/Chrome|Chromium|CriOS|Edg|OPR|Firefox|FxiOS|Android/i.test(ua);

  return !isSafari;
}
